import { FC } from 'react';
import { streamAccessTill } from '@/components/streams/stream-access-till/stream-access-till.css.ts';
import { formatDateShort } from '@/date-utils/format-date.ts';

export const StreamAccessTill: FC<{ cancelAt: string }> = ({ cancelAt }) => {
  return (
    <div className={streamAccessTill}>
      <span>You have access till {formatDateShort(new Date(cancelAt))}</span>
    </div>
  );
};
